import {
    HttpErrorResponse,
    HttpInterceptorFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError} from 'rxjs';

import { AuthService } from '@/Services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);
    const isLogin = req.url.endsWith('/Account/Login');
    const isRefresh = req.url.endsWith('/Account/RefreshToken');
    // No agregar Authorization al Login ni al Refresh
    if (
        isLogin || isRefresh
    ) {
        return next(
            req.clone({
                headers: req.headers.delete('Authorization')
            })
        );
    }

    // Si hay un refresh en curso, esperar antes de enviar la petición
    if (auth.isRefreshing()) {

        return auth.waitRefresh().pipe(

            switchMap(() => {
                const token = auth.getToken();
                return next(
                    token
                        ? req.clone({
                            setHeaders: {
                                Authorization: `Bearer ${token}`
                            }
                        })
                        : req
                );
            })
        );
    }

    const token = auth.getToken();

    const request = token
        ? req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        })
        : req;

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (
                error.status !== 401 ||
                error.error?.errorCodigo !== '50011'
            ) {
                return throwError(() => error);
            }

            console.log('JWT expirado. Ejecutando RefreshToken...');
            return auth.refreshToken().pipe(

                switchMap(() => {
                    const nuevoToken = auth.getToken();
                    return next(
                        req.clone({
                            setHeaders: {
                                Authorization: `Bearer ${nuevoToken}`
                            }
                        })
                    );
                }),

                catchError(refreshError => {
                    ///auth.logoutStorage();
                    return throwError(() => refreshError);
                })
            );
        })
    );
};